import React, { useEffect, useState } from "react";
import { toPersianNum, toEnglishNum } from "../../assets/utils";

import logo from "../../assets/img/logo.jpeg";
import { Link } from "react-router-dom";

const HeaderPu = () => {
  const getTime = () => {
    const date = new Date();

    const min = date.getMinutes();
    const hour = date.getHours();
    // console.log(min);
    return { min, hour };
  };

  const getDate = () => {
    const date = new Date();
    const datePer = new Date().toLocaleDateString("fa-IR");

    const seperated = datePer.split("/");

    const dayOfMonth = seperated[2];

    let dayOfWeek = date.getDay();
    switch (dayOfWeek) {
      case 0:
        dayOfWeek = "یک‌شنبه";
        break;

      case 1:
        dayOfWeek = "دوشنبه";
        break;

      case 2:
        dayOfWeek = "سه‌شنبه";
        break;

      case 3:
        dayOfWeek = "چهارشنبه";
        break;

      case 4:
        dayOfWeek = "پنج‌شنبه";
        break;

      case 5:
        dayOfWeek = "جمعه";
        break;

      case 6:
        dayOfWeek = "شنبه";
        break;

      default:
        break;
    }
    // console.log(dayOfWeek);

    let month = toEnglishNum(seperated[1]);
    switch (Number(month)) {
      case 1:
        month = "فروردین";
        break;
      case 2:
        month = "اردیبهشت";
        break;
      case 3:
        month = "خرداد";
        break;
      case 4:
        month = "تیر";
        break;
      case 5:
        month = "مرداد";
        break;
      case 6:
        month = "شهریور";
        break;
      case 7:
        month = "مهر";
        break;
      case 8:
        month = "آبان";
        break;
      case 9:
        month = "آ‌‌ذر";
        break;
      case 10:
        month = "دی";
        break;
      case 11:
        month = "بهمن";
        break;
      case 12:
        month = "اسفند";
        break;

      default:
        // month = "sd";
        break;
    }

    console.log(month);
    console.log(dayOfWeek);
    console.log(dayOfMonth);

    return { dayOfMonth, dayOfWeek, month };
  };

  const [time, setTime] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    const newTime = getTime();
    // console.log(time.hour);
    setTime(newTime);

    const newDate = getDate();
    setDate(newDate);
    // const newDate = new Date().toLocaleDateString("fa-IR");
    // setDate(newDate);

    const interval = setInterval(() => {
      const newTime = getTime();
      // console.log(time.hour);
      setTime(newTime);
    }, 60000);
    // const date = new Date();
    // console.log(date.getMinutes());
    return () => {
      // alert("hi");
      clearInterval(interval);
    };
  }, []);

  return (
    <header className="mx-4">
      {/* {console.log(date)} */}
      <div className="my-4 d-flex align-items-center justify-content-between">
        <a
          href="https://barnet.app/"
          target="_blank"
          rel="noreferrer"
          className="d-flex"
        >
          <div style={{ width: "45px", height: "45px" }}>
            <img
              src={logo}
              width="100%"
              alt=""
              style={{ verticalAlign: "middle" }}
            />
          </div>
          <div className="mr-2">
            <h2>بارنت</h2>
            <h3 className="font-weight-bold">اپلیکیشن حمل بار توافقی</h3>
          </div>
        </a>

        <div>
          <a
            href="https://barnet.app/app2/login"
            target="_blank"
            rel="noreferrer"
          >
            <button
              className="px-3 px-sm-5 py-2 font-weight-bold"
              style={{
                backgroundColor: "#FFBF1D",
                borderRadius: "10px",
                color: "white",
              }}
            >
              درخواست خودرو
            </button>
          </a>
        </div>
      </div>

      <Link to="/requests">
        <div
          className="d-flex  font-weight-bold text-white"
          style={{ fontSize: "3em", height: "120px" }}
        >
          <h1
            className="bg--blue-dark border--15 d-flex justify-content-center align-items-center text-center p-3"
            style={{ width: "calc(100% - 170px)" }}
          >
            تابلو اعلام بار سراسری بارنت
          </h1>
          <div
            className="d-flex align-items-center justify-content-around mr-4"
            style={{ fontSize: ".85em", width: "170px" }}
          >
            <div
              className="bg--blue-dark border--15 h-100 d-flex flex-column justify-content-center align-items-center p-1"
              style={{ flexBasis: "35%" }}
            >
              <div>{time.hour ? toPersianNum(time.hour) : null}</div>
              <div
                style={{ WebkitTextStroke: "1px white", color: "transparent" }}
              >
                {time.min ? toPersianNum(time.min) : null}
              </div>
            </div>
            <div
              className="bg--blue-dark border--15 h-100 d-flex flex-column justify-content-center align-items-center p-1"
              style={{ flexBasis: "35%" }}
            >
              <div style={{ fontSize: ".8rem", fontWeight: "normal" }}>
                {date ? date.dayOfWeek : null}
              </div>
              <div>{date ? date.dayOfMonth : null}</div>
              <div style={{ fontSize: ".8rem", fontWeight: "normal" }}>
                {date ? date.month : null}
              </div>
            </div>
          </div>
        </div>
      </Link>
    </header>
  );
};

export default HeaderPu;
